export type IShowFormGroupError = (element: IjQueryElmOrHtmlElm, message?: string) => void;

export function showFormGroupError(element: IjQueryElmOrHtmlElm, message = ''): void {
  const $formGroup = $(element).closest('.form-group');
  const $errorBlock = $formGroup.find('.error-block');
  $formGroup.removeClass('has-warning has-success').addClass('has-error');
  $errorBlock
    .removeClass('hide')
    .attr('aria-hidden', 'false')
    .text(message);
}
